import Vue from 'vue'
import MainComponent from './components/MainComponent.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(MainComponent),
}).$mount('#app')
